import React, { FC } from 'react';

import { styled } from '../theme';
import FlexColumn from './FlexColumn';

const StyledInput = styled('input')`
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: ${({ theme }) => theme.color.jetBlack};
    background-color: ${({ theme }) => theme.color.white};
    background-image: none;
    border: ${({ theme }) => theme.border.surface};
    border-radius: ${({ theme }) => theme.borderRadius.base}px;
    box-shadow: ${({ theme }) => theme.boxShadow.base1};
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;

    &:focus {
        border-color: #66afe9;
        outline: 0;
        box-shadow: ${({ theme }) => theme.boxShadow.surface};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.color.disabled};
        cursor: not-allowed;
    }
`;

type Props = {
    id: string;
    type?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};

const FormControl: FC<Props> = ({ id, type = 'text', value, onChange, disabled = false }) => (
    <FlexColumn>
        <StyledInput id={id} type={type} value={value} onChange={onChange} disabled={disabled} />
    </FlexColumn>
);

export default FormControl;
